module.exports = __webpack_public_path__ + "static/media/work1.3.2ef5aa7d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.3.webp
// module id = 522
// module chunks = 4